import { useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { isOutOfArena } from '../helpers/arenaHelper'

function useOutOfTheBox (elementRef) {
  const [isOut, setIsOut] = useState(false)
  useFrame(function() {
    // check off platform
    const { freeze } = elementRef.current?.userData || {}
    if (elementRef.current && elementRef.current?.position && !freeze) {
      if (isOutOfArena(elementRef)) {
        setIsOut(true)
      } else {
        setIsOut(false)
      }
    }
  })
  return isOut
}

export default useOutOfTheBox